import {Request} from '../classes/request';
import {hasFilledValue} from './dnsProblems';

/** Iperammortamento 4.0 (7) e DNS + Iperammortamento 4.0 (6). */
export const IPER_VIEW_TYPE_IDS = [6, 7];

/** Vista Iperammortamento 4.0: solo pratiche Completate di quei due tipi. */
export function isIperViewRequest(request: Pick<Request, 'FKIDRequestType' | 'ProgressStatus'>): boolean {
    return IPER_VIEW_TYPE_IDS.includes(Number(request.FKIDRequestType))
        && Number(request.ProgressStatus) === 10;
}

export const PREVENTIVE_FILE_PROBLEM = 'Richiesta comunicazione preventiva non inviata al cliente';
export const PREVENTIVE_SENT_PROBLEM = 'Comunicazione preventiva non inviata al GSE';
export const PREVENTIVE_RECEIPT_PROBLEM = 'Ricevuta comunicazione preventiva non generata dal GSE';
export const PREVENTIVE_EMAIL_PROBLEM = 'Email fase preventiva non inviata al cliente';
export const PARTICIPATION_FINANCIALS_PROBLEM = 'Società partecipata, inserire ULA, Totale Attivo e Ricavi Prestazioni';

export const IPER_PROBLEM_OPTIONS = [
    PREVENTIVE_FILE_PROBLEM,
    PREVENTIVE_SENT_PROBLEM,
    PREVENTIVE_RECEIPT_PROBLEM,
    PREVENTIVE_EMAIL_PROBLEM,
    PARTICIPATION_FINANCIALS_PROBLEM
];

export type IperPhase = 'preventiva' | 'intermedia' | 'completamento';

export const IPER_PHASE_FILTER_OPTIONS = ['Preventiva', 'Intermedia', 'Completamento'];

export function iperPhaseLabel(phase: IperPhase): string {
    if (phase === 'preventiva') {
        return 'Preventiva';
    }
    if (phase === 'intermedia') {
        return 'Intermedia';
    }
    return 'Completamento';
}

function isYes(value: unknown): boolean {
    return value === true || value === 1;
}

function hasParticipation(request: Request): boolean {
    return isYes(request.CompanyParticipation) || isYes(request.PartnersParticipation);
}

/** ULA, totale attivo e ricavi sono sul cliente collegato alla pratica. */
function hasMissingParticipationFinancials(request: Request): boolean {
    const customer = request.customer;
    return !hasFilledValue(customer?.ULALastBalance)
        || !hasFilledValue(customer?.TotalAssets)
        || !hasFilledValue(customer?.SalesRevenues);
}

export function iperProblemLabels(request: Request): string[] {
    const labels: string[] = [];
    if (!hasFilledValue(request.PreventiveFileClientSentDate)) {
        labels.push(PREVENTIVE_FILE_PROBLEM);
    }
    if (!hasFilledValue(request.PreventiveSentDate)) {
        labels.push(PREVENTIVE_SENT_PROBLEM);
    }
    if (!hasFilledValue(request.PreventiveReceiptDate)) {
        labels.push(PREVENTIVE_RECEIPT_PROBLEM);
    }
    if (!hasFilledValue(request.PreventiveClientSupplierEmailDate)) {
        labels.push(PREVENTIVE_EMAIL_PROBLEM);
    }
    if (hasParticipation(request) && hasMissingParticipationFinancials(request)) {
        labels.push(PARTICIPATION_FINANCIALS_PROBLEM);
    }
    return labels;
}

/**
 * Preventiva finché manca almeno un adempimento della comunicazione preventiva
 * o i dati economici di una società partecipata. Altrimenti Intermedia.
 * Completamento arriverà con le regole delle fasi successive.
 */
export function iperPhase(request: Request): IperPhase {
    return iperProblemLabels(request).length > 0 ? 'preventiva' : 'intermedia';
}

export function iperPhaseLabelOf(request: Request): string {
    return iperPhaseLabel(iperPhase(request));
}
